import React from "react";
import ModalImage from "react-modal-image";
function ImagePreviewer(props) {
	return (
		<>
			<div id="imgPrview">
				<ModalImage
					small={
						props.src
							? props.src
							: "https://www.pngitem.com/pimgs/m/150-1503945_transparent-user-png-default-user-image-png-png.png"
					}
					large={
						props.src
							? props.src
							: "https://www.pngitem.com/pimgs/m/150-1503945_transparent-user-png-default-user-image-png-png.png"
					}
					alt="Profile Image"
					className="profileThumnail"
					hideDownload={true}
				/>
			</div>
		</>
	);
}

export default ImagePreviewer;
